import { useState } from "react";
import {
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Menu,
  MenuItem,
  Box,
  Typography,
  Divider,
} from "@mui/material";
// import {
//   Dashboard,
//   Business,
//   ShoppingCart,
//   AccountBalance,
//   People,
//   BarChart,
//   Settings,
//   ChevronRight,
//   ArrowBack,
// } from "@mui/icons-material";
import {
  ChevronRight,
  ArrowBack,
  Dashboard,
  Business,
  ShoppingCart,
  AccountBalance,
  People,
  BarChart,
  KeyboardArrowDown,
  KeyboardArrowRight,
  Settings,
  AccountTree,
  Inventory2,
  Savings,
  MoreHoriz,
  BalanceOutlined,
  CategoryOutlined,
  LabelOutlined,
  Assignment,
  LocalShipping,
  AssignmentReturn,
  Summarize,
  ReceiptLong,
  PersonSearch,
  ViewList,
  RequestQuote,
  ShoppingBag,
  Undo,
  BarChartOutlined,
  GroupWork,
  PeopleAlt,
  ListAlt,
  TableChart,
  MoveToInbox,
  Outbox,
  CompareArrows,
  Timeline,
  Receipt,
} from "@mui/icons-material";

import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const MobileBottomNav = () => {
  const history = useHistory();
  const location = useLocation();
  const { permissions, isSuperAdmin, username } = useAuth();
  const [value, setValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  // SuperAdmin or privileged username bypasses all permission checks
  const hasFullAccess = isSuperAdmin || username === 'Baiju_Ta';

  // A section is accessible if the user has ANY claim for it (Read/Create/Edit/Delete/Cancel)
  const hasMasterAccess = hasFullAccess ||
    permissions.some(p => p.endsWith(' Master'));
  const hasTransactionAccess = hasFullAccess ||
    permissions.some(p => p.endsWith(' Transaction'));
  const hasAccountsAccess = hasFullAccess ||
    permissions.some(p => p.endsWith(' Accounts'));
  const hasAdministrationAccess = hasFullAccess ||
    permissions.some(p => p.endsWith(' Administration'));
  const hasReportsAccess = hasFullAccess ||
    permissions.some(p => p.endsWith(' Reports'));
  const hasAdminReportsAccess = hasFullAccess ||
    permissions.includes('UserRead AdminReports');

  const handleMenuOpen = (event, menuId) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(menuId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveMenu(null);
  };

  const handleNavigation = (path) => {
    history.push(path);
    handleMenuClose();
  };

  const menuItems = {
    master: [
      { label: 'Board',          route: '/BoardIndex' },
      { label: 'Frame',          route: '/FrameIndex' },
      { label: 'Glass',          route: '/GlassIndex' },
      { label: 'Hook',           route: '/HookIndex' },
      { label: 'Item',           route: '/ItemIndex' },
      { label: 'Lamination',     route: '/LaminationIndex' },
      { label: 'Mount',          route: '/MountIndex' },
      { label: 'Print',          route: '/PrintIndex' },
      { label: 'Size',           route: '/SizeIndex' },
      { label: 'Stand',          route: '/StandIndex' },
      { label: 'Tape',           route: '/TapeIndex' },
      { label: 'Master',         route: '/MasterIndex' },
      { label: 'Company',        route: '/CompanyEdit' },
      { label: 'Account Head',       route: '/AccHeadIndex' },
      { label: 'Bank',               route: '/BankIndex' },
    ],
    transactions: [
      { label: 'Estimate',       route: '/EstimateIndex' },
      { label: 'Bill',           route: '/BillIndex' },
      { label: 'Purchase',       route: '/PurchaseIndex' },
      { label: 'Petty Cash', route: '/PettyCashIndex' },
    ],
    accounts: [      
      { label: 'Payment & Receipts', route: '/PaymentAndReceiptIndex' },
      { label: 'Credit / Debit',     route: '/CreditDebitIndex' },
    ],
    settings: [
      { label: 'Users',          route: '/UserIndex' },
      { label: 'Roles',          route: '/RoleIndex' },
      { label: 'Reset Password', route: '/PasswordChange' },
    ],
    reports: [
      { label: 'Work Order Details', route: '/WorkOrderReport' },
      { label: 'Work Order Items',   route: '/WorkOrderItemsReport' },
      { label: 'Work Order (Due Date))',   route: '/WorkOrderDueDateRPT' },
      { label: 'Bill Statement',     route: '/BillStatementReport' },
      { label: 'Ledger',          route: '/AdminLedger' },      
      { label: 'Debtors List',    route: '/AdminDebtorsList' },
      { label: 'Creditors List',  route: '/AdminCreditorsList' },
      // { label: 'Ledger',             route: '/Ledger' },
      // { label: 'Cash Book',          route: '/CashBook' },
      // { label: 'Debtors List',       route: '/DebtorsList' },
      // { label: 'Creditors List',     route: '/CreditorsList' },
      // { label: 'Trial Balance',      route: '/TrialBalance' },
    ],
    adminReports: [      
      { label: 'Trial Balance',   route: '/AdminTrialBalance' },
      { label: 'Cash Book',       route: '/AdminCashBook' },
    ],
  };

  // Helper to check if a route is active
  const isActive = (route) => location.pathname === route || location.pathname.startsWith(route + '/');
  const isAnyActive = (routes) => routes.some(r => isActive(r));

  const isMasterActive      = isAnyActive(menuItems.master.map(i => i.route));
  const isTransactionsActive = isAnyActive(menuItems.transactions.map(i => i.route));
  const isAccountsActive    = isAnyActive(menuItems.accounts.map(i => i.route));
  const isSettingsActive    = isAnyActive(menuItems.settings.map(i => i.route));
  const isReportsActive     = isAnyActive(menuItems.reports.map(i => i.route));
  const isAdminReportsActive = isAnyActive(menuItems.adminReports.map(i => i.route));

  // Active style for menu items
  const activeItemSx = (route) => ({
    fontSize: '14px',
    py: 1.5,
    backgroundColor: isActive(route) ? 'rgba(201,168,76,0.2) !important' : 'transparent',
    borderLeft: isActive(route) ? '3px solid #c9a84c' : '3px solid transparent',
    color: isActive(route) ? '#c9a84c' : 'rgba(255,255,255,0.9)',
    fontWeight: isActive(route) ? 700 : 400,
    '&:hover': { backgroundColor: 'rgba(201,168,76,0.1) !important' },
  });

  const activeSubItemSx = (route) => ({
    fontSize: '13px',
    py: 1.2,
    backgroundColor: isActive(route) ? 'rgba(255,215,0,0.2) !important' : 'transparent',
    borderLeft: isActive(route) ? '3px solid #FFD700' : '3px solid transparent',
    color: isActive(route) ? '#FFD700' : 'white',
    fontWeight: isActive(route) ? 700 : 400,
    '&:hover': { backgroundColor: 'rgba(255,255,255,0.1) !important' },
  });

  return (
    <>
      <Paper
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
          borderTop: '1px solid rgba(0,0,0,0.1)',
        }}
        elevation={8}
      >
        <BottomNavigation
          value={value}
          onChange={(event, newValue) => setValue(newValue)}
          sx={{
            background: 'linear-gradient(135deg, #3b2410 0%, #5c3d1e 100%)',
            height: '60px',
            borderTop: '2px solid #c9a84c',
            '& .MuiBottomNavigationAction-root': {
              color: 'rgba(255,255,255,0.6)',
              minWidth: '50px',
              padding: '6px 0',
              '&.Mui-selected': { color: '#c9a84c' },
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: '10px', fontWeight: 500, marginTop: '2px',
            },
          }}
        >
          <BottomNavigationAction
            label="Home"
            icon={<Dashboard sx={{ fontSize: 22, color: isActive('/Home') ? '#c9a84c' : 'inherit' }} />}
            onClick={() => history.push('/Home')}
            sx={{ borderTop: isActive('/Home') ? '2px solid #c9a84c' : '2px solid transparent', color: isActive('/Home') ? '#c9a84c !important' : 'rgba(255,255,255,0.6)' }}
          />
          {hasMasterAccess && (
          <BottomNavigationAction
            label="Master"
            icon={<Business sx={{ fontSize: 22, color: isMasterActive ? '#c9a84c' : 'inherit' }} />}
            onClick={(e) => handleMenuOpen(e, 'master')}
            sx={{ borderTop: isMasterActive ? '2px solid #c9a84c' : '2px solid transparent', color: isMasterActive ? '#c9a84c !important' : 'rgba(255,255,255,0.6)' }}
          />
          )}
          {hasTransactionAccess && (
          <BottomNavigationAction
            label="Txn"
            icon={<ReceiptLong sx={{ fontSize: 22, color: isTransactionsActive ? '#c9a84c' : 'inherit' }} />}
            onClick={(e) => handleMenuOpen(e, 'transactions')}
            sx={{ borderTop: isTransactionsActive ? '2px solid #c9a84c' : '2px solid transparent', color: isTransactionsActive ? '#c9a84c !important' : 'rgba(255,255,255,0.6)' }}
          />
          )}
          {hasAccountsAccess && (
          <BottomNavigationAction
            label="Accounts"
            icon={<AccountBalance sx={{ fontSize: 22, color: isAccountsActive ? '#c9a84c' : 'inherit' }} />}
            onClick={(e) => handleMenuOpen(e, 'accounts')}
            sx={{ borderTop: isAccountsActive ? '2px solid #c9a84c' : '2px solid transparent', color: isAccountsActive ? '#c9a84c !important' : 'rgba(255,255,255,0.6)' }}
          />
          )}
          {hasReportsAccess && (
          <BottomNavigationAction
            label="Reports"
            icon={<BarChart sx={{ fontSize: 22, color: isReportsActive ? '#c9a84c' : 'inherit' }} />}
            onClick={(e) => handleMenuOpen(e, 'reports')}
            sx={{ borderTop: isReportsActive ? '2px solid #c9a84c' : '2px solid transparent', color: isReportsActive ? '#c9a84c !important' : 'rgba(255,255,255,0.6)' }}
          />
          )}
          {hasAdminReportsAccess && (
          <BottomNavigationAction
            label="Admin"
            icon={<AccountBalance sx={{ fontSize: 22, color: isAdminReportsActive ? '#c9a84c' : 'inherit' }} />}
            onClick={(e) => handleMenuOpen(e, 'adminReports')}
            sx={{ borderTop: isAdminReportsActive ? '2px solid #c9a84c' : '2px solid transparent', color: isAdminReportsActive ? '#c9a84c !important' : 'rgba(255,255,255,0.6)' }}
          />
          )}
          {hasAdministrationAccess && (
          <BottomNavigationAction
            label="More"
            icon={<Settings sx={{ fontSize: 22, color: isSettingsActive ? '#c9a84c' : 'inherit' }} />}
            onClick={(e) => handleMenuOpen(e, 'settings')}
            sx={{ borderTop: isSettingsActive ? '2px solid #c9a84c' : '2px solid transparent', color: isSettingsActive ? '#c9a84c !important' : 'rgba(255,255,255,0.6)' }}
          />
          )}
        </BottomNavigation>
      </Paper>

      {/* Master Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'master'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: 'linear-gradient(160deg, #3b2410 0%, #5c3d1e 100%)',
            color: 'white',
            borderRadius: '12px',
            border: '1px solid rgba(201,168,76,0.3)',
            minWidth: '180px',
            mb: 1,
          }
        }}
      >
        {menuItems.master.map((item, idx) => (
          <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeItemSx(item.route)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>

      {/* Transactions Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'transactions'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: 'linear-gradient(160deg, #3b2410 0%, #5c3d1e 100%)',
            color: 'white', borderRadius: '12px',
            border: '1px solid rgba(201,168,76,0.3)', minWidth: '180px', mb: 1,
          }
        }}
      >
        {menuItems.transactions.map((item, idx) => (
          <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeItemSx(item.route)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>

      {/* Accounts Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'accounts'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: 'linear-gradient(160deg, #3b2410 0%, #5c3d1e 100%)',
            color: 'white', borderRadius: '12px',
            border: '1px solid rgba(201,168,76,0.3)', minWidth: '180px', mb: 1,
          }
        }}
      >
        {menuItems.accounts.map((item, idx) => (
          <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeItemSx(item.route)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>

      {/* Reports Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'reports'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: 'linear-gradient(160deg, #3b2410 0%, #5c3d1e 100%)',
            color: 'white', borderRadius: '12px',
            border: '1px solid rgba(201,168,76,0.3)', minWidth: '180px', mb: 1,
          }
        }}
      >
        {menuItems.reports.map((item, idx) => (
          <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeItemSx(item.route)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>

      {/* Admin Reports Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'adminReports'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: 'linear-gradient(160deg, #3b2410 0%, #5c3d1e 100%)',
            color: 'white', borderRadius: '12px',
            border: '1px solid rgba(201,168,76,0.3)', minWidth: '180px', mb: 1,
          }
        }}
      >
        {menuItems.adminReports.map((item, idx) => (
          <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeItemSx(item.route)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>

      {/* Settings Menu */}      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'settings'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: 'linear-gradient(160deg, #3b2410 0%, #5c3d1e 100%)',
            color: 'white',
            borderRadius: '12px',
            border: '1px solid rgba(201,168,76,0.3)',
            minWidth: '180px',
            mb: 1,
          }
        }}
      >
        {menuItems.settings.map((item, idx) => (
          <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeItemSx(item.route)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MobileBottomNav;
